import { render, staticRenderFns } from "./EmployeeSpouseInfo.vue?vue&type=template&id=3656c811"
import script from "./EmployeeSpouseInfo.vue?vue&type=script&lang=js"
export * from "./EmployeeSpouseInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports